import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
            <div className="md:col-span-4">
              <Link to="/" className="block cursor-pointer">
                <span className="text-4xl font-heading text-background-50 tracking-wide">
                  178漫画网
                </span>
              </Link>
              <p className="mt-6 text-sm text-foreground-400 leading-relaxed max-w-xs">
                178漫画网是一个专注于免费漫画阅读的在线平台，提供丰富多样的漫画资源。涵盖校园恋爱、热血运动、日常搞笑、奇幻冒险等多种分类，让每一位漫迷都能在这里找到心仪的作品。
              </p>
              <div className="flex items-center gap-4 mt-8">
                <a
                  href="#"
                  className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-100 transition-colors cursor-pointer"
                  aria-label="微博"
                >
                  <i className="ri-links-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-100 transition-colors cursor-pointer"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-100 transition-colors cursor-pointer"
                  aria-label="B站"
                >
                  <i className="ri-movie-line text-lg"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-5">
                热门分类
              </h4>
              <div className="flex flex-col gap-3">
                {categories.slice(0, 6).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-5">
                快速链接
              </h4>
              <div className="flex flex-col gap-3">
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  首页
                </Link>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  关于我们
                </Link>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  读者协议
                </a>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  隐私政策
                </a>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  帮助中心
                </a>
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-5">
                联系我们
              </h4>
              <div className="flex flex-col gap-3">
                <p className="text-sm text-foreground-400 leading-relaxed">
                  北京市朝阳区<br />望京科技园B座1206
                </p>
                <p className="text-sm text-foreground-400">010-8888-6666</p>
                <a
                  href="mailto:hello@91cghlw.cn"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  hello@91cghlw.cn
                </a>
              </div>
            </div>

            <div className="md:col-span-2">
              <div className="w-full h-40 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20people%20reading%20manga%20on%20mobile%20phone%20in%20cozy%20cafe%2C%20warm%20lighting%2C%20relaxed%20atmosphere%2C%20casual%20style%2C%20editorial%20photography%2C%20soft%20focus%2C%20youth%20culture%2C%20natural%20pose&width=400&height=500&seq=footer-img-01&orientation=portrait"
                  alt="178漫画网 阅读体验"
                  title="178漫画网 移动端阅读"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2020-2026 178漫画网 版权所有 | 京ICP备2020XXXXXX号
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}